import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import purchaseOrderConfig from './config/purchaseOrderConfig';
import setViewTitle from '../../helpers/setViewTitle';
import moment from 'moment';
import SimplePage from '../common/SimplePage';

var PurchaseOrderHistory = createReactClass({

  getInitialState() {
    return {
      history: [],
    };
  },

  componentWillMount() {
    setViewTitle('Historie');
  },

  componentDidMount() {
    this.reloadData();
  },

  reloadData() {
    request.get({
      url: purchaseOrderConfig.apiUrl + 'history/',
      success: history => {
        if (this.isMounted()) {
          this.setState({
            history
          });
        }
      }
    });
  },

  render() {
    let orderLinks = this.state.history.map(h => {
      let createdString = moment(h.purchaseOrder.dateCreated).format('DD.MM.YYYY HH:mm:ss');
      let modifiedString = moment(h.purchaseOrder.dateModified).format('DD.MM.YYYY HH:mm:ss');

      const rowStyle = {
        backgroundColor: h.purchaseOrder.orderWithoutStorage ? '#f2fbff' : 'white'
      };

      return (
        <tr key={h.id} style={rowStyle}>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{h.purchaseOrder.documentNo}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{h.purchaseOrder.vendorName}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{modifiedString}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{createdString}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{h.hasBeenRejected ? 'Ja' : 'Nein'}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{h.hasBeenClosed ? 'Ja' : 'Nein'}</Link></td>
            <td><Link to={`/purchaseordershistory/${h.id}`}>{h.purchaseOrder.orderWithoutStorage ? 'Ja' : 'Nein'}</Link></td>
        </tr>
      );
    });

    return (
      <SimplePage title="Historie" icon="truck">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Dokument Nr</th>
                <th>Lieferant</th>
                <th>Geändert am</th>
                <th>Erstellt am</th>
                <th>Abgelehnt</th>
                <th>Abgeschlossen </th>
                <th>Bestellung ohne Lagerführung</th>
              </tr>
            </thead>
            <tbody>
              {orderLinks}
            </tbody>
          </table>
        </div>
      </SimplePage>
    );
  }

});

export default PurchaseOrderHistory;



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderHistory.js